export const ticketsData = [
  {
    key: "1",
    ticketId: "#4987",
    subject: "Support for theme",
    assignedName: "Richard",
    assignedAvatar: "assets/img/profiles/avatar-02.jpg",
    assignedDate: "22 Sep 2023",
    createdOn: "25 Sep 2023, 12:12 pm",
    dueDate: "25 Dec 2023",
    assigneeName: "Darlee Robertson",
    role: "Facility Manager",
    assigneeAvatar: "assets/img/profiles/avatar-19.jpg",
    lastReply: "27 Sep 2023",
    priority: "Medium",
    status: "Resolved",
  },
  {
    key: "2",
    ticketId: "#4988",
    subject: "verify your email",
    assignedName: "Elizabeth",
    assignedAvatar: "assets/img/profiles/avatar-01.jpg",
    assignedDate: "23 Sep 2023",
    createdOn: "26 Sep 2023, 12:12 pm",
    dueDate: "30 Dec 2023",
    assigneeName: "Sharon Roy",
    role: "Installer",
    assigneeAvatar: "assets/img/profiles/avatar-20.jpg",
    lastReply: "30 Sep 2023",
    priority: "Low",
    status: "Closed",
  },
  {
    key: "3",
    ticketId: "#4989",
    subject: "Calling for help",
    assignedName: "Michel",
    assignedAvatar: "assets/img/profiles/avatar-04.jpg",
    assignedDate: "24 Sep 2023",
    createdOn: "27 Sep 2023, 12:12 pm",
    dueDate: "25 Jan 2024",
    assigneeName: "Vaughan",
    role: "Senior Manager",
    assigneeAvatar: "assets/img/profiles/avatar-21.jpg",
    lastReply: "01 Oct 2023",
    priority: "High",
    status: "Pending",
  },
  {
    key: "4",
    ticketId: "#4990",
    subject: "Management",
    assignedName: "Esther",
    assignedAvatar: "assets/img/profiles/avatar-03.jpg",
    assignedDate: "30 Sep 2023",
    createdOn: "05 Oct 2023, 11:10 pm",
    dueDate: "31 Jan 2023",
    assigneeName: "Jessica",
    role: "Test Engineer",
    assigneeAvatar: "assets/img/profiles/avatar-23.jpg",
    lastReply: "10 Oct 2023",
    priority: "Medium",
    status: "Resolved",
  },
  {
    key: "5",
    ticketId: "#4991",
    subject: "Calling for help",
    assignedName: "Wilson",
    assignedAvatar: "assets/img/profiles/avatar-05.jpg",
    assignedDate: "22 Sep 2023",
    createdOn: "25 Sep 2023, 12:12 pm",
    dueDate: "25 Dec 2023",
    assigneeName: "Carol Thomas",
    role: "UI / UX Designer",
    assigneeAvatar: "assets/img/profiles/avatar-16.jpg",
    lastReply: "27 Sep 2023",
    priority: "Low",
    status: "Open",
  },
  {
    key: "6",
    ticketId: "#4992",
    subject: "Support for theme",
    assignedName: "Walter",
    assignedAvatar: "assets/img/profiles/avatar-06.jpg",
    assignedDate: "30 Sep 2023",
    createdOn: "05 Oct 2023, 12:12 pm",
    dueDate: "25 Dec 2023",
    assigneeName: "Dawn Mercha",
    role: "Technician",
    assigneeAvatar: "assets/img/profiles/avatar-22.jpg",
    lastReply: "07 Oct 2023",
    priority: "High",
    status: "Closed",
  },
];
